import { useEffect, useMemo, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchShare } from '../utils/firestoreService';

const T = {
  orange:'var(--orange)', orangeD:'var(--orange-d)', ink:'#1C1612', bg:'#FDFAF6', surface:'#FFFFFF',
  border:'#EAE4DC', muted:'#8A7E72', subtle:'#B5A99A',
};
const FONT    = "'Inter',-apple-system,BlinkMacSystemFont,sans-serif";
const DISPLAY = "'Bangers','Arial Black',cursive";

export default function SharedCollectionPage() {
  const { shareId } = useParams();
  const [state, setState] = useState({ loading:true, error:null, share:null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const share = await fetchShare(shareId);
        if (!cancelled) setState({ loading:false, error: share ? null : 'not-found', share });
      } catch {
        if (!cancelled) setState({ loading:false, error:'error', share:null });
      }
    })();
    return () => { cancelled = true; };
  }, [shareId]);

  const groups = useMemo(() => {
    const items = state.share?.items || [];
    const bySerie = {};
    items.forEach(it => {
      const k = it.serie?.trim() || 'Sans série';
      (bySerie[k] = bySerie[k] || []).push(it);
    });
    Object.values(bySerie).forEach(list => list.sort((a,b)=>(parseInt(a.numero)||0)-(parseInt(b.numero)||0)));
    return Object.entries(bySerie).sort((a,b)=>a[0].localeCompare(b[0],'fr'));
  }, [state.share]);

  return (
    <div style={{minHeight:'100vh', background:T.bg, fontFamily:FONT}}>
      <div style={{maxWidth:'680px', margin:'0 auto', padding:'1.5rem 1.25rem 3rem'}}>

        <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'1.5rem'}}>
          <div style={{width:'38px',height:'38px',borderRadius:'10px',background:T.orange,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'18px',flexShrink:0}}>📚</div>
          <div style={{fontFamily:DISPLAY,fontSize:'1.4rem',letterSpacing:'.05em',color:T.orange}}>Bulléthèque</div>
        </div>

        {state.loading && (
          <div style={{textAlign:'center',padding:'3rem 1rem',color:T.muted,fontSize:'14px'}}>Chargement…</div>
        )}

        {state.error==='not-found' && (
          <div style={{textAlign:'center',padding:'3rem 1rem'}}>
            <div style={{fontSize:'2.2rem',marginBottom:'8px'}}>🔍</div>
            <div style={{fontSize:'15px',fontWeight:700,color:T.ink}}>Lien introuvable</div>
            <div style={{fontSize:'13px',color:T.muted,marginTop:'4px'}}>Ce lien n'existe plus ou a expiré.</div>
          </div>
        )}

        {state.error==='error' && (
          <div style={{textAlign:'center',padding:'3rem 1rem',color:T.muted,fontSize:'13px'}}>Impossible de charger cette page pour le moment.</div>
        )}

        {state.share && (
          <>
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:'16px',padding:'1.25rem',marginBottom:'1.25rem'}}>
              <div style={{fontSize:'18px',fontWeight:700,color:T.ink,marginBottom:'2px'}}>{state.share.title}</div>
              <div style={{fontSize:'13px',color:T.muted}}>{state.share.items.length} tome{state.share.items.length>1?'s':''} · {groups.length} série{groups.length>1?'s':''}</div>
            </div>

            {groups.length === 0 && (
              <div style={{textAlign:'center',padding:'2rem 1rem',color:T.muted,fontSize:'13px'}}>Rien à afficher.</div>
            )}

            {groups.map(([serie, list]) => (
              <div key={serie} style={{marginBottom:'16px'}}>
                <div style={{fontSize:'11px',fontWeight:700,color:T.orange,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:'6px'}}>
                  {serie} <span style={{color:T.muted,fontWeight:600}}>· {list.length}</span>
                </div>
                <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:'12px',overflow:'hidden'}}>
                  {list.map((it,i) => (
                    <div key={i} style={{display:'flex',alignItems:'center',gap:'10px',padding:'9px 12px',borderBottom:i<list.length-1?`1px solid ${T.border}`:'none'}}>
                      <div style={{width:'38px',flexShrink:0,fontSize:'12px',fontWeight:700,color:T.muted}}>T.{it.numero||'?'}</div>
                      <div style={{minWidth:0,flex:1}}>
                        {it.titre && <div style={{fontSize:'13px',fontWeight:600,color:T.ink,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{it.titre}</div>}
                        {(it.editeur||it.auteur||it.etat||it.prix||it.statut) && (
                          <div style={{fontSize:'11px',color:T.muted,marginTop:it.titre?'1px':0}}>
                            {[it.editeur,it.auteur,it.etat,it.prix?`${it.prix}€`:null,it.statut].filter(Boolean).join(' · ')}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div style={{textAlign:'center',marginTop:'2rem',paddingTop:'1.5rem',borderTop:`1px solid ${T.border}`}}>
              <div style={{fontSize:'12px',color:T.subtle,marginBottom:'10px'}}>Propulsé par Bulléthèque — gère ta propre collection de BD</div>
              <Link to="/login" style={{display:'inline-block',padding:'9px 18px',borderRadius:'99px',background:T.orange,color:'#fff',fontFamily:FONT,fontSize:'13px',fontWeight:700,textDecoration:'none'}}>
                Créer ma collection
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
